<template>
    <div>
        <basic-container>
            <avue-crud :option="tableOption"
                       :data="tableData"
                       :table-loading="tableLoading"
                       :page="page"
                       ref="crud"
                       @search-change="searchChange"
                       @refresh-change="refreshChange(page)"
                       @size-change="pageSizeChange"
                       @current-change="pageChange">
                <!-- <template slot-scope="scope" slot="menuLeft">
                    <el-button type="primary"
                               icon="el-icon-plus"
                               size="small"
                               plain
                               v-if="payment=='BATCH_RANDOM_COLLECTION'||payment=='BATCH_QUOTA_RECEIVE'"
                               @click.stop="tableToExcel()"
                    >下载二维码链接
                    </el-button>
                </template> -->
                <template slot-scope="scope" slot="menu">
                </template>
                <template slot-scope="scope" slot="status">
                    <el-tag v-for="obj of detailStatusList" :key="obj.value" v-if="obj.value == scope.row.status">
                        {{obj.label}}
                    </el-tag>
                </template>
                 <template slot-scope="scope" slot="menuLeft">
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            plain
            @click.stop="downloadExcel()"
            >下载Excel
          </el-button>
          <el-button 
          type="primary"
          icon="el-icon-plus"
          size="small"
          plain
          v-if="payment=='BATCH_RANDOM_COLLECTION'||payment=='BATCH_QUOTA_RECEIVE'"
          @click.stop="tableToExcel()"
          >下载二维码链接
          </el-button>
        </template>
            </avue-crud>
             <!-- <el-dialog title="下载Excel" :visible.sync="detailVisible">
          <el-form
            :inline="true"
            :model="detailSearch"
            label-width="80px"
            size="small"
          >
            <el-form-item label="领取方式" :span="6">
              <el-select
                v-model="detailSearch.payment"
                required
                value-key="value"
              >
                <el-option
                  v-for="status in detailStatusList"
                  :key="status.value"
                  :label="status.label"
                  :value="status"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="红包名称" :span="6">
              <el-input v-model="detailSearch.redpacketName"></el-input>
            </el-form-item>
            <el-form-item :span="6">
              <el-button
                class="el-button el-button--primary el-button--small"
                @click.stop="downloadExcel()"
              >
                <i class="el-icon-download"></i>
                下载Excel
              </el-button>
            </el-form-item>
          </el-form>
        </el-dialog> -->
        </basic-container>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {redPacketDetailsOption} from "@/const/salesCloud/scanRedDetailsOption";
    import { findRedPacketDetail,downloadQrCodeLink,downloadExcel} from "@/api/salesCloud/scanRedDetails"
    import {findByLabel, formatterTime} from "@/util/util"
    import {DIC} from "@/const/dic"

    export default {
        name: "redPacketDetails",
        data() {
            return {
                tableOption: redPacketDetailsOption, //表格设置属性
                tableData: [], //表格的数据
                tablePage: 1,
                tableLoading: false,
                tabelObj: {},
                
                page: {
                    total: 0, //总页数
                    currentPage: 1, //当前页数
                    pageSize: 10 //每页显示多少条
                },
                grade: {
                    box: false,
                    check: []
                },
                detailVisible: false,
                detailData: [],
                selectRedPacket: {

                },
                detailSearch: {
                },
                detailPage: {
                    total: 0,
                    currentPage: 1,
                    pageSize: 10
                },
                detailStatusList: DIC.SALES_RED_PACKED_DETAIL_STATUS,
                redPacketStatus: DIC.SALES_RED_PACKED_STATUS,
                id:this.$route.query.id,
                payment:this.$route.query.payment,
                downloadData:{}
            };
        },
        created() {
            this.handleList();
        },
        watch: {},
        mounted() {
        },
        computed: {
            ...mapGetters(["permission"])
        },
        props: [],
        methods: {
            pageSizeChange(pageSize) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = this.page.currentPage,
                    params.size = pageSize
                params.redPacketId = this.id
                this.downloadData = params;
                findRedPacketDetail(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: this.page.currentPage,
                        pageSize: pageSize
                    };
                    this.tableLoading = false;
                })
            },
            pageChange(page) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = page
                params.size = this.page.pageSize
                params.redPacketId = this.id
                this.downloadData = params;
                findRedPacketDetail(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: page,
                        pageSize: this.page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            searchChange(params) {
                this.tableLoading = true;
                params.redPacketId = this.id
                // let params = this.$refs.crud.searchForm
                params.page = this.page.currentPage
                params.size = this.page.pageSize
                if (
                    null != params.startDate_endDate &&
                    undefined != params.startDate_endDate &&
                    "" != params.startDate_endDate
                ) {
                    params.startTime = params.startDate_endDate[0];
                    params.endTime = params.startDate_endDate[1];
                } else {
                    delete params.startTime;
                    delete params.endTime;
                }
                this.downloadData = params;
                findRedPacketDetail(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: params.page,
                        pageSize: params.size
                    };
                    this.tableLoading = false;
                })
            },
            refreshChange(page) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = page.currentPage
                params.size = page.pageSize
                params.redPacketId = this.id
                this.downloadData = params;
                findRedPacketDetail(params).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: page.currentPage,
                        pageSize: page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            //下载
            openDetailVisible() {
              this.detailVisible = true;
            },
            downloadExcel() {
            let params = this.downloadData;
            downloadExcel(params).then((res) => {
                    window.open(res);
                });
            },
            /**
             * @title 获取数据
             * @detail 赋值为tableData表格即可
             *
             **/
            handleList() {
                this.tableLoading = true;
                let parmas = {
                    page: this.page.currentPage,
                    size: this.page.pageSize,
                    redPacketId:this.id
                }
                this.downloadData = parmas;
                findRedPacketDetail(parmas).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: this.page.currentPage,
                        pageSize: this.page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            tableToExcel(){
                downloadQrCodeLink(this.id);
            }

        }
    };
</script>

<style lang="scss">
    .table-container {
        padding: 8px 10px;
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
</style>
